import { ReportDateRange } from '@decisions/server/DecisionsFramework/Design/Flow/CoreSteps/Metro/ReportDateRange';
import { FilterDateRange } from '@decisions/server/DecisionsFramework/Design/Page/Filters';
import { DateRangeFilter } from 'components/DateRangeFilter/DateRangeFilter';
import React, { useState, useCallback } from 'react';
import { getISODateStringWithUtcOffset } from 'utils/DateTimeUtils';
import { IEditorProps } from '../Editor';
import { EditorLabel } from '../EditorLabel';
import { useScopeHandlers } from './hooks/useScopeHandlers';
import { PersonalizationScopeSelector } from './PersonalizationScopeSelector';

interface IFilterDateRangeEditorEditorProps extends IEditorProps {}

/**
 * Editor for a filter range (personalization) data-filter editor.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function FilterDateRangeEditor({ child, path, onChange, hideInputLabel }: IFilterDateRangeEditorEditorProps) {
  const [value, setValue] = useState(child.Value.OutputValue as FilterDateRange);
  const { personalization } = useScopeHandlers({ value, path, setValue, onChange });

  const onDateRangeChange = useCallback(
    (dateRange: ReportDateRange) => {
      const newVal = { ...value, DateRange: dateRange };
      if (newVal.DateRange?.FromDate?.toJSON) {
        // JSON.stringify converts the date to UTC equivalent hence overriding the toJSON method here
        newVal.DateRange.FromDate.toJSON = function() {
          return getISODateStringWithUtcOffset(this);
        };
      }
      setValue(newVal);
      onChange(newVal, path);
    },
    [onChange, path, value]
  );

  return (
    <EditorLabel editor={child} path={path}>
      <div className="dp-filter-date-range">
        <DateRangeFilter
          disableRollingRange={true}
          wrapperClass="dp-filter-date-range__wrapper"
          buttonClass="dp-filter-date-range__button"
          showInLayer={true}
          onSelectionChange={onDateRangeChange}
          dateRangeFilterData={value.DateRange}
        />
        <PersonalizationScopeSelector {...personalization} />
      </div>
    </EditorLabel>
  );
}
